import { css } from 'styled-components';
import token from 'styled-token';

/** @class PhotoCarouselDotsMixin */
/** @method */
export var PhotoCarouselDotsMixin = function PhotoCarouselDotsMixin() {
  return token({
    bottom: 'PhotoCarousel.dot.position.bottom',
    maxDotHeight: 'PhotoCarousel.dot.size.lg'
  }, function (_ref) {
    var bottom = _ref.bottom,
      maxDotHeight = _ref.maxDotHeight;
    return css(["position:absolute;left:50%;transform:translateX(-50%);z-index:5;bottom:", "px;line-height:", "px;"], bottom, maxDotHeight);
  });
};